import { render, staticRenderFns } from "./CardCarouselTab.vue?vue&type=template&id=97501a6e&"
import script from "./CardCarouselTab.vue?vue&type=script&lang=js&"
export * from "./CardCarouselTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports